import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
//import { Loader2, CheckCircle, XCircle } from 'lucide-react';
//import { Button } from '@/components/ui/button';
//import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
// import { Alert, AlertDescription } from '@/components/ui/alert';
import './unsubscripe.css'; // Importera din CSS-fil här
import Footer from '../Components/Footer';
import Navigation from '../Components/Navigation';
import Loader from '../Components/Loader';
import { DataService } from '../DataService/DataService';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'valid' | 'invalid' | 'unsubscribed' | 'error'>('loading');
  const [isProcessing, setIsProcessing] = useState(false);

  const token = searchParams.get('sub') || searchParams.get('id') || searchParams.get('key');
    console.log(token)

  const validateToken = useCallback(async () => {
    if (!token) {
      setStatus('invalid');
      return;
    }

    try {
      const valid = await DataService.EmailList.ValidadeEntry(token);
      setStatus(valid ? 'valid' : 'invalid');
    } catch (error) {
      setStatus('error');
    }
  }, [token]);

  useEffect(() => {
    void validateToken();
  }, [validateToken]);

  const handleUnsubscribe = async () => {
    setIsProcessing(true);
    try {
        const unsubscribed = await DataService.EmailList.UnsubscribeFromNewslist(token as string);
        setStatus(unsubscribed ? 'unsubscribed' : 'error');
        setIsProcessing(false);
    } catch (error) {
      setStatus('error');
      setIsProcessing(false);
    }
  };

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return (
          <div className="text-center loading-message">
            {/* <Loader2 className="icon-md spinner" /> */}
            <p className="text-secondary">Verifierar dina uppgifter...</p>
            <div style={{position:'relative',display:'flex',justifyContent:'center'}}><Loader loaderSize={'LARGE'} bgColor='#4b5563'/></div>
          </div>
        );

      case 'valid':
        return (
          <div className="text-center">
            <h2 className="heading text-primary">Avprenumerera från nyhetsbrevet</h2>
            <p className="text-secondary description">
              Är du säker på att du vill avprenumerera från vårt nyhetsbrev?
              Du kommer inte längre att få uppdateringar om nya kurser och tips.
            </p>
            <div className="button-group">
              <button
                onClick={handleUnsubscribe}
                disabled={isProcessing}
                /*className='submit-button'*/
                className="button button-destructive"
              >
                {isProcessing ? (
                  <>
                    <div style={{position:'relative',display:'flex',justifyContent:'center'}}><Loader loaderSize={'LARGE'} bgColor='#4b5563'/></div>
                    Avprenumererar...
                  </>
                ) : (
                  'Ja, avprenumerera'
                )}
              </button>
              <button
                /*className="button button-outline"*/
                className='submit-button'
                onClick={() => window.close()}
              >
                Nej, behåll prenumerationen
              </button>
            </div>
          </div>
        );

      case 'unsubscribed':
        return (
          <div className="text-center">
            {/* <CheckCircle className="icon-lg success-text" /> */}
            <h2 className="heading text-primary">Avprenumeration genomförd</h2>
            <p className="text-secondary description">
              Du har framgångsrikt avprenumererat från vårt nyhetsbrev.
              Vi kommer inte att skicka fler e-postmeddelanden till dig.
            </p>
            <p className="text-small">
              Tack för att du har varit en del av vår community!
            </p>
          </div>
        );

      case 'invalid':
        return (
          <div className="text-center">
            {/* <XCircle className="icon-lg error-text" /> */}
            <h2 className="heading text-primary">Ogiltiga uppgifter</h2>
            <div className="alert">
              {/* <AlertDescription> */}
                Uppgifterna som du har angett stämmer inte. Länken kan vara ogiltig eller ha gått ut.
              {/* </AlertDescription> */}
            </div>
            <p className="text-secondary description">
              Om du fortfarande vill avprenumerera från vårt nyhetsbrev, vänligen kontakta oss direkt.
            </p>
            
            <button className='submit-button'/*className="button button-outline"*/ onClick={() => window.location.href = '/'}>
              Tillbaka till startsidan
            </button>
          </div>
        );

      case 'error':
        return (
          <div className="text-center">
            {/* <XCircle className="icon-lg error-text" /> */}
            <h2 className="heading text-primary">Ett fel uppstod</h2>
            <div className="alert">
              {/* <AlertDescription> */}
                Ett tekniskt fel uppstod när vi försökte behandla din begäran. Försök igen senare.
              {/* </AlertDescription> */}
            </div>
            <button /*className="button button-outline"*/className='submit-button' onClick={() => void validateToken()}>
              Försök igen
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{minHeight: '100vh'}}>
         {/* <Navigation /> */}
    <div className="unsubscribe-page">
      <div className="unsubscribe-container">
        {/* <Card className="unsubscribe-card">
          <CardHeader>
            <CardTitle className="text-center">Nyhetsbrev</CardTitle>
          </CardHeader>
          <CardContent> */}
          <div className='unsubscribe-card'>
            {renderContent()}
            </div>
          {/* </CardContent>
        </Card> */}
      </div>
    </div>
    {/* <Footer/> */}
    </div>
  );
};

export default Unsubscribe;
